import { Link } from "react-router-dom";
import WhatsAppLogo from "@/assets/whatsapp.png";

const WHATSAPP_CLAIM_URL =
  "https://wa.me/919324095283?text=Hi%2C%20I%20want%20to%20raise%20a%20request";

export default function HowItWorks() {
  return (
    <section className="tw-relative tw-bg-[#EDEDED] tw-py-10 tw-text-black tw-overflow-hidden">
      {/* phone image sits behind the copy on md+ */}
      <img
        src="/nestroot/HowItWorks.png"
        alt="Claims Process on Phone"
        className="tw-hidden md:tw-block tw-absolute tw-opacity-90 tw-object-contain md:tw-right-0 md:tw-bottom-0 md:tw-w-1/2 md:tw-h-[60%] lg:tw-left-[45.5%] lg:tw-top-10 lg:tw-bottom-auto lg:tw-w-[51%] lg:tw-h-[612px]"
      />

      <div className="tw-relative tw-z-10 tw-w-[90%] md:tw-w-4/5 tw-mx-auto tw-flex tw-flex-col md:tw-min-h-[600px]">
        <h2
          className="tw-text-[36px] tw-leading-10 tw-text-center tw-font-bold tw-pb-10"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          How it works
        </h2>

        <div className="tw-flex-1 tw-flex tw-items-center">
          <div className="tw-w-full md:tw-w-1/2 tw-flex tw-flex-col tw-items-start">
            <h3 className="tw-text-3xl md:tw-text-5xl tw-leading-tight md:tw-leading-[48px] tw-font-semibold tw-pb-6">
              Easy claims, great service
            </h3>

            <p className="tw-max-w-[512px] tw-text-xl md:tw-text-2xl tw-leading-8 tw-opacity-90 tw-pb-10">
              Filing a claim is simple. Share a few details about what
              happened, and our team will review your claim and email you the
              details of your next steps.
            </p>

            {/* buttons shrink on phones so both labels fit side by side */}
            <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 md:tw-gap-4">
              <Link
                to="/customer-login"
                className="tw-rounded-full tw-border tw-border-black tw-px-6 tw-py-3 md:tw-px-8 md:tw-py-4 tw-text-base md:tw-text-xl tw-leading-6 md:tw-leading-7 tw-font-bold tw-text-black tw-no-underline hover:tw-bg-[#f1b324] hover:tw-border-[#f1b324] tw-transition-colors"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                Start a Claim
              </Link>

              <a
                href={WHATSAPP_CLAIM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="tw-flex tw-items-center tw-justify-center tw-gap-2 md:tw-gap-0 tw-rounded-full tw-border tw-border-black tw-px-5 tw-py-3 md:tw-px-4 md:tw-py-2 tw-text-black tw-no-underline hover:tw-bg-[#f1b324] hover:tw-border-[#f1b324] tw-transition-colors"
              >
                <img
                  src={WhatsAppLogo}
                  alt="WhatsApp"
                  width={24}
                  height={24}
                  className="tw-h-5 tw-w-5 md:tw-h-6 md:tw-w-6 tw-shrink-0 tw-object-contain"
                />
                <span className="md:tw-px-4 md:tw-py-2 tw-text-base md:tw-text-lg tw-leading-6 md:tw-leading-7 tw-font-bold">
                  Quick Claim
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
